import React from "react";
import styles from "../../pages/renewal/Renew.module.css";

/**
 * Reusable status indicator for async lookups (Make ID, Model ID).
 * Shows a spinner while loading, a checkmark on success, or an X on error.
 *
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether the lookup is in progress
 * @param {'success'|'error'|null} props.status - Result status
 * @param {string} [props.loadingText="Fetching..."] - Text shown while loading
 * @param {string} [props.successText="Found"] - Text shown on success
 * @param {string} [props.errorText="Not found"] - Text shown on error
 */
const StatusIndicator = ({
  isLoading,
  status,
  loadingText = "Fetching...",
  successText = "Found",
  errorText = "Not found",
}) => {
  if (isLoading) {
    return (
      <div className={styles.status_loading}>
        <span className={styles.status_spinner}></span>
        {loadingText}
      </div>
    );
  }

  if (status === "success") {
    return <div className={styles.status_success}>✓ {successText}</div>;
  }

  if (status === "error") {
    return <div className={styles.status_error}>✗ {errorText}</div>;
  }

  return null;
};

export default StatusIndicator;
